import { IAppState } from "./app.inteface";
import { DialogConfig, BlockerConfig } from '@/interfaces';

const token = localStorage.getItem('token');

export const state: IAppState = {
  load: null,
  logged: false,
  loading: false,
  snackbar: null,
  token: token ? token : "",
	expiredTokenDialog: false,
	dialog: new DialogConfig(),
	blocker: new BlockerConfig(),
	
	timestampUsers: "",
	timestampInvoices: "",
	timestampCustomers: "",
	timestampStaff: "", 
};
